import * as betstride from './DepositLimitModal.styles.betstride';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  betstride,
};
